import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Router } from 'react-router-dom';
import { createMemoryHistory } from 'history';

function IsomorphicRouter({ children, fullpath }) {
  if (typeof window !== 'undefined') {
    return <BrowserRouter>{children}</BrowserRouter>;
  }

  const memoryHistory = createMemoryHistory({ initialEntries: [fullpath] });

  return <Router history={memoryHistory}>{children}</Router>;
}

IsomorphicRouter.propTypes = {
  children: PropTypes.node.isRequired,
  fullpath: PropTypes.string.isRequired
};

export default IsomorphicRouter;
